import gsap from 'gsap';
import {isInView} from '../helpers/isInView';
import Sine from 'gsap';

export function setUpLogo(logoArrow, logoLoad){
    logoArrow.addEventListener('mouseenter', () => {
        const firstBreak = document.querySelector('.full-width:first-child');
        const firstBreakinView = isInView(firstBreak);
        if(!firstBreakinView){
            gsap.to(
                logoArrow,
                {
                    opacity: 0, 
                    duration: 0.2,
                    ease: Sine.easeOut
                }
            )
            gsap.to(
                logoLoad,
                {
                    opacity: 1, 
                    duration: 0.4,
                    ease: Sine.easeOut
                }
            )
        }
    })
    logoArrow.addEventListener('mouseleave', () => {
        const firstBreak = document.querySelector('.full-width:first-child');
        const firstBreakinView = isInView(firstBreak);
        if(!firstBreakinView){
            gsap.to(
                logoLoad,
                {
                    opacity: 0, 
                    duration: 0.2,
                    ease: Sine.easeOut
                }
            )
            gsap.to(
                logoArrow,
                {
                    opacity: 1, 
                    duration: 0.4,
                    ease: Sine.easeOut
                }
            )
        }
    })
}

export function handleLogo(start){
    const firstBreak = document.querySelector('.full-width:first-child');
    const logoHome = document.getElementById('logoHome');
    const logoLoad = document.getElementById('logoLoad');
    const logoArrow = document.getElementById('logoArrow');
    const mainContainer = document.getElementById('main-container');
    const isIntro = document.getElementById('landing-page-container') !== null;
    const firstBreakinView = firstBreak !== null ? isInView(firstBreak) : false;
    if(firstBreakinView){
        const elements = logoArrow !== null ? [logoArrow, logoLoad] : [logoLoad]
        gsap.to(elements,{
            opacity: 0,
            duration: 0.2,
            ease: Sine.easeOut,
        })
        gsap.to(logoHome,{
            opacity: 1,
            duration: 0.2,
            ease: Sine.easeOut,
            onComplete: function(){
                if(start){
                    mainContainer.classList.remove('start');
                }
            }
        })
    }else{
        gsap.to([logoHome, logoLoad],{
            opacity: 0,
            duration: 0.2,
            ease: Sine.easeOut
        })
        if(!isIntro && logoArrow !== null){
            gsap.to(logoArrow,{
                opacity: 1,
                duration: 0.2,
                ease: Sine.easeOut
            })
        } 
    }
}